export default __webpack_public_path__ + "static/media/assigned_services.f57798a1.svg";